import React, {  } from 'react'
import PageWrapper from '../Components/Other/PageWrapper'
import { useEffect } from 'react';
import Sevices from '../Components/Home/Sevices'
import Specialists from '../Components/Home/Specialists'
import ChooseUs from '../Components/Home/ChooseUs'
import DoctorsTeam from '../Components/Home/DoctorsTeam'
import OurNews from '../Components/Home/OurNews'
import Banner from '../Components/Home/Banner'
import {CommonApiFun} from '../Redux/Action/index'
import { useDispatch } from 'react-redux';
import VideoSection from '../Components/Home/VideoSection';
function Home(props) {
const dispatch=useDispatch()
    useEffect(() => {
        var data = { action: "clinic" }
        dispatch(CommonApiFun("api/Api_controller/post", JSON.stringify(data))).then((res) => {
            if (res.status == "success") {
                dispatch({ type: 'CLINIC_INFO', payload: res.data })
                dispatch({ type: 'CONSULTATION_INFO', payload: res.online_consultation })

            } else {
                // toast(<ToastMgs status={"Cancelled"} message={"Something went wrong please try again ...."} />)
            }

        }).catch((e) => {
            //toast(<ToastMgs status={"Cancelled"} message={"Something went wrong please try again ...."} />)
        })
    }, [])
    return (

            <PageWrapper className={"index-page"}>
          
                <div className="shopWrapper">
              
                    <Banner></Banner>
                    <VideoSection></VideoSection>
                    <Sevices></Sevices>
                    <Specialists></Specialists>
                    <ChooseUs></ChooseUs>
                    <DoctorsTeam></DoctorsTeam>
                    <OurNews></OurNews>
                </div>

            </PageWrapper>

    );
}

export default Home;